<div class="relative h-full w-full flex flex-col items-center justify-center overflow-hidden">
    @if (images() && images()!.length > 0) {
    <div class="group relative h-full w-full">
        @if (images().length > 1) {
        <div
            class="pointer-events-none absolute top-[calc(50%-20px)] z-10 hidden w-full flex-row items-center justify-between px-2 group-hover:flex">
            <button (click)="nextSlide(-1)" type="button" class="fab-button-subtle pointer-events-auto text-secondary"
                aria-label="Previous image">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5"
                    aria-hidden="true">
                    <path d="m15 18-6-6 6-6" />
                </svg>
            </button>

            <button (click)="nextSlide(1)" type="button" class="fab-button-subtle pointer-events-auto text-secondary"
                aria-label="Next image">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5"
                    aria-hidden="true">
                    <path d="m9 18 6-6-6-6" />
                </svg>
            </button>
        </div>
        }

        <div class="carousel-viewport h-full w-full overflow-hidden">
            <div class="carousel-track flex h-full flex-row ease-out" [style.width.%]="trackWidthPercent()"
                [style.transform]="trackTransform()">
                @for (image of images(); track $index) {
                <div class="h-full shrink-0 overflow-hidden" [style.flex]="'0 0 ' + slideBasisPercent() + '%'">
                    <img [src]="image.s3_url" alt="" class="h-full w-full object-cover" />
                </div>
                }
            </div>
        </div>

        @if (images().length > 1) {
        <div class="absolute bottom-0 left-0 z-[5] flex h-10 w-full flex-row items-center justify-center gap-x-1.5 bg-gradient-to-t from-black/50 to-transparent pt-2"
            role="tablist" aria-label="Carousel slides">
            @for (image of images(); track $index; let i = $index) {
            <button type="button" class="size-2 cursor-pointer rounded-full transition-colors"
                [class]="selectedIndex() === i ? 'bg-white' : 'bg-white/50'"
                [attr.aria-label]="'Slide ' + (i + 1) + ' of ' + images().length"
                [attr.aria-current]="selectedIndex() === i ? 'true' : null" (click)="selectSlide(i)"></button>
            }
        </div>
        }
    </div>
    }
</div>